import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'sonner';

import { AlertConfiguration, showAlert } from '@/slice/AlertSlice';
import { Variants } from '@/types/common';
import type { RootState } from '@/store/store';

/**
 * Global alert listener that bridges Redux AlertSlice to Sonner toasts.
 * Renders no UI — all notifications are handled by the Sonner Toaster.
 */
function AlertListener() {
  const dispatch = useDispatch();
  const alertConfiguration: AlertConfiguration | null = useSelector(
    (state: RootState) => state.alertState.configuration
  );

  useEffect(() => {
    if (alertConfiguration && alertConfiguration.type !== Variants.CLEANUP) {
      const message = alertConfiguration.message || '';
      // Undefined falls back to the Toaster's own duration.
      const options = { duration: alertConfiguration.duration };

      switch (alertConfiguration.type) {
        case Variants.SUCCESS:
          toast.success(message, options);
          break;
        case Variants.ERROR:
          toast.error(message, options);
          break;
        case Variants.WARNING:
          toast.warning(message, options);
          break;
        case Variants.INFO:
          toast.info(message, options);
          break;
        default:
          toast(message, options);
          break;
      }

      setTimeout(() => {
        dispatch(showAlert({ type: Variants.CLEANUP }));
      }, 300);
    }
  }, [alertConfiguration, dispatch]);

  return null;
}

export default AlertListener;
